import { toClsMetric } from './cls';
import { toInpMetric } from './inp';
import { toLcpMetric } from './lcp';
import { toTtfbMetric } from './ttfb';
import { toFcpMetric } from './fcp';
import { toPageMetric } from './page';
export const metricsMapper = {
    INP: toInpMetric,
    CLS: toClsMetric,
    LCP: toLcpMetric,
    TTFB: toTtfbMetric,
    FCP: toFcpMetric,
    Page: toPageMetric,
};
//# sourceMappingURL=index.js.map